import siteType from "../configs/siteType"

/* eslint-disable */
let register = {}
if (siteType.GetSiteType() == siteType.SITE_TYPE_NUTS) {
  register = {
    "LAB_CLUB_INVITE_H5_WELCOME": "欢迎来到{club}",
    "LAB_CLUB_INVITE_H5_WELCOME_LONG": "注册成功后你将加入这个俱乐部",
    "LAB_REGISTER_USERNAME": "用户名",
    "LAB_AUTH_EMAIL": "电子邮箱",
    "LAB_ACCOUNT_EMAIL_FORM_WRONG": "信箱格式不正确",
    "LAB_ACCOUNT_ALREADY_REGISTERED": "* 该信箱已注册。",
    "LAB_KYC_INVALID_EMAIL": "无法使用此邮箱。",
    "LAB_ACCOUNT_FORMAT_TIP": "*用户名应由4-30个英文或数字组成。",
    "LAB_ACCOUNT_FORMAT_TIP2": "*用户名不能包含空格和特殊字符。",
    "LAB_PASSWORD": "密码",
    "LAB_REGISTER_PASSWORD_TIP2": "密码应由数字和字母组合，长度在6-16位",
    "LAB_REGISTER_PASSWORD_TIP3": "{word} 不可在密码中使用。",
    "LAB_REGISTER_PASSWORD_TIP4": "不可在密码中使用空格。",
    "LAB_CLUB_INVITE_H5_Verifiy": "验证码",
    "LAB_VERIFICATION_CODE_ERROR": "验证码输入错误",
    "LAB_REGISTER_RIGHT_NOW": "立即注册",
    "LAB_CLUB_INVITE_H5_Download_1": "已有账号?",
    "LAB_CLUB_INVITE_H5_Download_2": "立即下载",
    "LAB_CLUB_INVITE_H5_Success": "注册成功",
    "LAB_CLUB_CHECK_TEMS1": "已年满18周岁，已阅读并同意",
    "LAB_CLUB_CHECK_TEMS2": "《服务条款》",
    "LAB_CLUB_CHECK_TEMS3": "和",
    "LAB_CLUB_CHECK_TEMS4": "《隐私条款》",
    "LAB_CLUB_CHECK_TIPS": "未同意协议条款",
    "LAB_REGISTER_MUCH": "注册次数过多!",
    "LAB_CLUB_INVITE_CODE_ERROR": "邀请码错误",
    "LAB_HISTORY_SHARE_ERROR": "请求失败，请稍后重试。",
    "LAB_H5_Marketing_Programme": "《联盟行销计划条款》",
    "LAB_H5_CHECK_TIPS": "请勾选表示你已年满18岁并已阅读及同意: {link1}﹑{link2}及{link3}。",
    "LAB_PLAY_NOW": "立即参与",
    "LAB_TITLE_1": "GUARANTEED CASHBACK",
    "LAB_CONTENT_1": "Up to 50% Instant Rakeback can be collected after every game!",
    "LAB_TITLE_2": "GLOBAL PLAYERS",
    "LAB_CONTENT_2": "A variety of exciting games running 24/7!",
    "LAB_TITLE_3": "NON-STOP BONUSES ",
    "LAB_CONTENT_3": "Play to earn HUGE rewards from our Leaderboards, Cash Storm, Mission and Jackpots.",
    "LAB_TITLE_4": "FUNDS PROTECTED",
    "LAB_CONTENT_4": "Tier-1 online poker license by the Isle of Man Gambling Commission.",
    "LAB_BE_MORE": "Be more than a player at NUTS POKER!",
    "LAB_PLAY_BEST": "Play the Best Poker Game Now!",
    "LAB_SERVICE": "The products and services that NUTS POKER offers (via its websites, tablet and mobile applications) are together referred to as the \"Services\".",
    "LAB_ENJOY": "ENJOY DIVERSE \nPOKER FORMATS",
    "LAB_MORE": "NLH, PLO, OFC & More! ",
    "LAB_PLAY_GAME": "Play with us to explore a wide variety of poker games!",
    "LAB_MODE": "From classic to trendy, we offer various poker games to enjoy, including No-Limit Texas Hold'em, PLO, 6+, and OFC - featuring thrilling variants including Aggressive, Ultimate and Joker modes.",
    "LAB_TODAY": "Take part in the action today!",
    "LAB_ACTION": "TRIPLE ACTION \nTRIPLE FUN",
    "LAB_MASTER": "Become a Multi-Table Master",
    "LAB_SAME_TIME": "The Multi-table feature allows you to play up to \nthree tables on your device at the same time!",
    "LAB_SWIPE": "For the best user-experience, tables are automatically highlighted \nwhen it’s your turn, moving you to the next piece of the action in a swipe.",
    "LAB_SAFE": "SAFE AND FAIR \nGAME EXPERIENCE",
    "LAB_ASSEM": "Dedicated Anti-Cheating Team Assembled!",
    "LAB_RULES": "NUTS POKER takes a zero-tolerance approach to unfair play, \nand will permanently ban accounts found to violate rules. ",
    "LAB_TABLES": "Anti-cheating mechanisms are implemented to ensure behaviour detection, \nwith a team of experts monitoring tables.",
    "LAB_EVERY_DAY": "Enjoy a fair and safe game at NUTS POKER every day!",
    "LAB_ACCESS": "Access to Services may not be legal for residents of, or persons located in,  {link}. Services provided hereunder do not constitute an offer, solicitation or invitation by NUTS POKER for the use of, or subscription to, betting, gaming or other services in any jurisdiction in which such activities are prohibited by law. In particular, residents of or persons located in the United States shall not use any of the Services.",
    "LAB_BRAND": "NUTS POKER is a brand and registered business name, owned by AceKing IOM Limited, 49 Victoria Street, Douglas, Isle of Man, IM1 2LD.",
    "LAB_GAMEBLING": "Regulated & Licensed by Isle of Man Gambling Supervision Commission pursuant to the Online Gambling",
    "LAB_AGE": "Regulation Act 2001 since 24th July, 2019 (Last Renewal: 24th July, 2019).Persons under the age of 18 are not allowed to create accounts and/or participate in gambling.Any deposits or winnings with NUTS POKER are secure and can be enforced by Isle of Man law.",
    "LAB_FOLLOW": "FOLLOW US",
    "LAB_COUNTRIES": "certain countries",
    "LAB_ABOUT": "About Us",
    "LAB_POLICY": "Privacy Policy",
    "LAB_TERM": "Terms of Service",
    "LAB_COPY": "Copyright © {link} NUTS POKER. All Rights Reserved.",
    "LAB_DOWNLOAD": "DOWNLOAD",
    "LAB_VERIFICATION": "驗證",
    "LAB_PLEASE_TYPE": "請輸入圖中的文字",
    "LAB_CONFIRM": "確認",
    "LAB_SERVICE_CO": "The products and services that NUTS POKER Global offers (via its websites, tablet and mobile applications) are together referred to as the “Services”.",
    "LAB_ACCESS_CO": "Access to Services may not be legal for residents of, or persons located in, {link}. Services provided hereunder do not constitute an offer, solicitation or invitation by NUTS POKER Global for the use of, or subscription to, betting, gaming or other services in any jurisdiction in which such activities are prohibited by law. In particular, residents of or persons located in the United States shall not use any of the Services.",
    "LAB_GAMEBLING_CO": "Any deposits or winnings with NUTS POKER Global are secure and can be enforced by Curaçao law.",
    "LAB_AGE_CO": "Persons under the age of 18 are not allowed to create accounts and/or participate in gambling.",
    "LAB_CLUB_CHECK_TEMS4_CO": "《隐私及个人数据管理条款》",
    "LAB_PRIVACYPOLICE_CO": "Privacy & Personal Data",
    "LAB_CONTENT_4_CO": "Fully licensed and regulated by Curaçao eGaming.\n",
    "LAB_VERIFY_EMAIL": "驗證您的電子郵件",
    "LAB_VERIFY_EMAIL_ADDRESS": "我們已經發送了一封電子郵件至 {email address}",
    "LAB_VERIFY_TIPS": "為了驗證您的電子郵件地址並啟用您的帳戶，請在您的郵箱中點擊驗證鏈接。這封郵件有可能在您的垃圾郵件文件夾中。",
    "LAB_VERIFY_RESEND": "重新發送郵件",
    "LAB_VERIFY_CODE_TIPS": "請輸入文本以驗證您不是機器人",
    "LAB_EMAIL_VERIFIED": "電子郵件已驗證",
    "LAB_EMAIL_DOWNLOAD_TIPS": "您的帳戶已成功創建。<br>點擊下方按鈕下載 NUTS POKER 開始遊戲。",
    "LAB_EMAIL_DOWNLOAD": "下載NUTS POKER。",
    "LAB_EMAIL_VERIFY_ACCOUNT": "驗證您的NUTS POKER帳戶",
    "LAB_EMAIL_EXPIRED_1": "糟糕，該鏈接已經過期",
    "LAB_EMAIL_EXPIRED_2": "請前往註冊頁面重新註冊並獲取新的鏈接",
    "LAB_VERIFY_PROTECT": "查看我們如何保護你的資料安全",
    "LAB_EMAIL_FAILED": "失败，请稍后重试"
  }
} else {
  register = {
    "LAB_CLUB_INVITE_H5_WELCOME": "欢迎来到{club}",
    "LAB_CLUB_INVITE_H5_WELCOME_LONG": "注册成功后你将加入这个俱乐部",
    "LAB_REGISTER_USERNAME": "用户名",
    "LAB_AUTH_EMAIL": "电子邮箱",
    "LAB_ACCOUNT_EMAIL_FORM_WRONG": "信箱格式不正确",
    "LAB_ACCOUNT_ALREADY_REGISTERED": "* 该信箱已注册。",
    "LAB_KYC_INVALID_EMAIL": "无法使用此邮箱。",
    "LAB_ACCOUNT_FORMAT_TIP": "*用户名应由4-30个英文或数字组成。",
    "LAB_ACCOUNT_FORMAT_TIP2": "*用户名不能包含空格和特殊字符。",
    "LAB_PASSWORD": "密码",
    "LAB_REGISTER_PASSWORD_TIP2": "密码应由数字和字母组合，长度在6-16位",
    "LAB_REGISTER_PASSWORD_TIP3": "{word} 不可在密码中使用。",
    "LAB_REGISTER_PASSWORD_TIP4": "不可在密码中使用空格。",
    "LAB_CLUB_INVITE_H5_Verifiy": "验证码",
    "LAB_VERIFICATION_CODE_ERROR": "验证码输入错误",
    "LAB_REGISTER_RIGHT_NOW": "立即注册",
    "LAB_CLUB_INVITE_H5_Download_1": "已有账号?",
    "LAB_CLUB_INVITE_H5_Download_2": "立即下载",
    "LAB_CLUB_INVITE_H5_Success": "注册成功",
    "LAB_CLUB_CHECK_TEMS1": "已年满18周岁，已阅读并同意",
    "LAB_CLUB_CHECK_TEMS2": "《服务条款》",
    "LAB_CLUB_CHECK_TEMS3": "和",
    "LAB_CLUB_CHECK_TEMS4": "《隐私条款》",
    "LAB_CLUB_CHECK_TIPS": "未同意协议条款",
    "LAB_REGISTER_MUCH": "注册次数过多!",
    "LAB_CLUB_INVITE_CODE_ERROR": "邀请码错误",
    "LAB_HISTORY_SHARE_ERROR": "请求失败，请稍后重试。",
    "LAB_H5_Marketing_Programme": "《联盟行销计划条款》",
    "LAB_H5_CHECK_TIPS": "请勾选表示你已年满18岁并已阅读及同意: {link1}﹑{link2}及{link3}。",
    "LAB_PLAY_NOW": "立即参与",
    "LAB_TITLE_1": "GUARANTEED CASHBACK",
    "LAB_CONTENT_1": "Up to 50% Instant Rakeback can be collected after every game!",
    "LAB_TITLE_2": "GLOBAL PLAYERS",
    "LAB_CONTENT_2": "A variety of exciting games running 24/7!",
    "LAB_TITLE_3": "NON-STOP BONUSES ",
    "LAB_CONTENT_3": "Play to earn HUGE rewards from our Leaderboards, Cash Storm, Mission and Jackpots.",
    "LAB_TITLE_4": "FUNDS PROTECTED",
    "LAB_CONTENT_4": "Tier-1 online poker license by the Isle of Man Gambling Commission.",
    "LAB_BE_MORE": "Be more than a player at KKPoker!",
    "LAB_PLAY_BEST": "Play the Best Poker Game Now!",
    "LAB_SERVICE": "The products and services that KKPoker offers (via its websites, tablet and mobile applications) are together referred to as the \"Services\".",
    "LAB_ENJOY": "ENJOY DIVERSE \r\nPOKER FORMATS",
    "LAB_MORE": "NLH, PLO, OFC & More! ",
    "LAB_PLAY_GAME": "Play with us to explore a wide variety of poker games!",
    "LAB_MODE": "From classic to trendy, we offer various poker games to enjoy, including No-Limit Texas Hold'em, PLO, 6+, and OFC - featuring thrilling variants including Aggressive, Ultimate and Joker modes.",
    "LAB_TODAY": "Take part in the action today!",
    "LAB_ACTION": "TRIPLE ACTION \r\nTRIPLE FUN",
    "LAB_MASTER": "Become a Multi-Table Master",
    "LAB_SAME_TIME": "The Multi-table feature allows you to play up to \r\nthree tables on your device at the same time!",
    "LAB_SWIPE": "For the best user-experience, tables are automatically highlighted \r\nwhen it’s your turn, moving you to the next piece of the action in a swipe.",
    "LAB_SAFE": "SAFE AND FAIR \r\nGAME EXPERIENCE",
    "LAB_ASSEM": "Dedicated Anti-Cheating Team Assembled!",
    "LAB_RULES": "KKPoker takes a zero-tolerance approach to unfair play, \r\nand will permanently ban accounts found to violate rules. ",
    "LAB_TABLES": "Anti-cheating mechanisms are implemented to ensure behaviour detection, \r\nwith a team of experts monitoring tables.",
    "LAB_EVERY_DAY": "Enjoy a fair and safe game at KKPoker every day!",
    "LAB_ACCESS": "Access to Services may not be legal for residents of, or persons located in,  {link}. Services provided hereunder do not constitute an offer, solicitation or invitation by KKPoker for the use of, or subscription to, betting, gaming or other services in any jurisdiction in which such activities are prohibited by law. In particular, residents of or persons located in the United States shall not use any of the Services.",
    "LAB_BRAND": "KKPoker is a brand and registered business name, owned by AceKing IOM Limited, 49 Victoria Street, Douglas, Isle of Man, IM1 2LD.",
    "LAB_GAMEBLING": "Regulated & Licensed by Isle of Man Gambling Supervision Commission pursuant to the Online Gambling",
    "LAB_AGE": "Regulation Act 2001 since 24th July, 2019 (Last Renewal: 24th July, 2019).Persons under the age of 18 are not allowed to create accounts and/or participate in gambling.Any deposits or winnings with KKPoker are secure and can be enforced by Isle of Man law.",
    "LAB_FOLLOW": "FOLLOW US",
    "LAB_COUNTRIES": "certain countries",
    "LAB_ABOUT": "About Us",
    "LAB_POLICY": "Privacy Policy",
    "LAB_TERM": "Terms of Service",
    "LAB_COPY": "Copyright © {link} KKPoker. All Rights Reserved.",
    "LAB_DOWNLOAD": "DOWNLOAD",
    "LAB_VERIFICATION": "驗證",
    "LAB_PLEASE_TYPE": "請輸入圖中的文字",
    "LAB_CONFIRM": "確認",
    "LAB_SERVICE_CO": "The products and services that KKPoker Global offers (via its websites, tablet and mobile applications) are together referred to as the “Services”.",
    "LAB_ACCESS_CO": "Access to Services may not be legal for residents of, or persons located in, {link}. Services provided hereunder do not constitute an offer, solicitation or invitation by KKPoker Global for the use of, or subscription to, betting, gaming or other services in any jurisdiction in which such activities are prohibited by law. In particular, residents of or persons located in the United States shall not use any of the Services.",
    "LAB_BRAND_CO": "kkpoker.co is operated by Violet Fortune Tech Limited N.V. registered under No. 158923 at, Perseusweg 27A, Willemstad, Curaçao. This website is licensed and regulated by Curaçao eGaming (Curaçao license No. 1668 JAZ issued by Curaçao eGaming).",
    "LAB_GAMEBLING_CO": "Any deposits or winnings with KKPoker Global are secure and can be enforced by Curaçao law.",
    "LAB_AGE_CO": "Persons under the age of 18 are not allowed to create accounts and/or participate in gambling.",
    "LAB_CLUB_CHECK_TEMS4_CO": "《隐私及个人数据管理条款》",
    "LAB_PRIVACYPOLICE_CO": "Privacy & Personal Data",
    "LAB_CONTENT_4_CO": "Fully licensed and regulated by Curaçao eGaming.\r\n",
    "LAB_VERIFY_EMAIL": "驗證您的電子郵件",
    "LAB_VERIFY_EMAIL_ADDRESS": "我們已經發送了一封電子郵件至 {email address}",
    "LAB_VERIFY_TIPS": "為了驗證您的電子郵件地址並啟用您的帳戶，請在您的郵箱中點擊驗證鏈接。這封郵件有可能在您的垃圾郵件文件夾中。",
    "LAB_VERIFY_RESEND": "重新發送郵件",
    "LAB_VERIFY_CODE_TIPS": "請輸入文本以驗證您不是機器人",
    "LAB_EMAIL_VERIFIED": "電子郵件已驗證",
    "LAB_EMAIL_DOWNLOAD_TIPS": "您的帳戶已成功創建。<br>點擊下方按鈕下載 KKpoker 開始遊戲。",
    "LAB_EMAIL_DOWNLOAD": "下載KKPOKER。",
    "LAB_EMAIL_VERIFY_ACCOUNT": "驗證您的KKPoker帳戶",
    "LAB_EMAIL_EXPIRED_1": "糟糕，該鏈接已經過期",
    "LAB_EMAIL_EXPIRED_2": "請前往註冊頁面重新註冊並獲取新的鏈接",
    "LAB_VERIFY_PROTECT": "查看我們如何保護你的資料安全",
    "LAB_EMAIL_FAILED": "失败，请稍后重试"
  }
}

export default {
  "register": register
}